import { publicInstance } from "../axios";

export const getProfileDetails = async () => {
  return await publicInstance
    .get("/profile")
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
};
export const getAddress = async () => {
  return await publicInstance
    .get("/user-address")
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
};
export const getEditAddress = async (id) => {
  return await publicInstance
    .get("/user-address?id="+id)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
};
export const getReturnList = async (id) => {
  return await publicInstance
    .get("/get-order-product?id="+id)
    .then((res) => {
      if (res.data.status === 200) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
};


export const updateProfileDetails = async (formData) => {
  const submitData = {
    firstName: `${formData.firstname}`,
    lastName: `${formData.lastname}`,
    userId: formData.userId,
  };

  return await publicInstance
    .post("/profile", submitData)
    .then((res) => {
      if (res.data.status === 200) {
        return res.data;
      } else {
        return [];
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const addContactDetails = async (formData) => {
  const submitData = {
    fullname: `${formData.fullname}`,
    email: `${formData.email}`,
    phonenumber: `${formData.phonenumber}`,
    subject: `${formData.subject}`,
    message: `${formData.message}`,
    userId: formData.userId,
  };

  return await publicInstance
    .post("/contact-messages", submitData)
    .then((res) => {
      if (res.data.status === 200) {
        return res.data;
      } else {
        return res.data;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const updateProfilePassword = async (formData) => {
  const submitData = {
    currentPassword: `${formData.currentpassword}`,
    newPassword: `${formData.newpassword}`
  };

  return await publicInstance
    .post("/password-reset", submitData)
    .then((res) => {
      if (res.data.status === 200) {
        return res.data;
      } else {
        return res.data;
      }
    })
    .catch((error) => {
      return "API error";
    });
};

export const cancelOrder = async (formData) => {
  const submitData = {
    orderId: `${formData.orderId}`,
    returnReason: `${formData.returnReason}`,
    returnHolder: `${formData.returnHolder}`,
    returnIban: `${formData.returnIban}`
  };

  return await publicInstance
    .post("/cancel-order", submitData)
    .then((res) => {
      if (res.data.status === 200) {
        return res.data;
      } else {
        return res.data;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const getOrders = async (id,year) => {
  
  return await publicInstance
    .get("/order?id="+id+"&year="+year)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
  
};
export const getOrderReview = async (id) => {
  
  return await publicInstance
    .get("/reviews?orderItemId="+id)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
  
};
export const postReview = async (formData) => {
  const submitData = {
    orderItemId: `${formData.orderItemId}`,
    message: `${formData.message}`,
    rating: `${formData.rating}`,
  };

  return await publicInstance
    .post("/reviews", submitData)
    .then((res) => {
      if (res.data.status === 200) {
        return res.data;
      } else {
        return res.data;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const postreturnItems = async (formData) => {
  const submitData = {
    orderItemId: `${formData.orderItemId}`,
    returnReason: `${formData.returnReason}`,
    returnHolder: `${formData.returnHolder}`,
    returnIban:`${formData.returnIban}`,
  };

  return await publicInstance
    .post("/return", submitData)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data;
      } else return [];
    })
    .catch((error) => {
      return "API error";
    });
};
export const getreturnItems = async (id) => {
  
  return await publicInstance
    .get("/return?orderId="+id)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
  
};
export const newsletter = async (formData) => {
  const submitData = {
    email: `${formData.email}`,
  };

  return await publicInstance
    .post("/newsletter", submitData)
    .then((res) => {
      if (res.data.status === 200) {
        return res.data;
      } else {
        return res.data;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const getWishlist = async (id) => {
  
  return await publicInstance
    .get("/wishlist")
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
  
};
export const deleteWishlist = async (id) => {
  
  return await publicInstance
    .delete("/wishlist?id="+id)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
  
};
export const deleteAddress = async (id) => {
  
  return await publicInstance
    .delete("/user-address?id="+id)
    .then((res) => {
      if (res.data && res.data.status) {
        return res.data.data;
      } else return [];
    })
    .catch((error) => {
      return [];
    });
  
};
